angular.module('portal-api', [])
	.service('PortalApi', PortalApiService);

PortalApiService.$inject = ['$q', '$http', '$timeout', '$state', 'Restangular'];
function PortalApiService($q, $http, $timeout, $state, Restangular) {
	var session = Restangular.all('session');
	var user = Restangular.all('user');
	var users = Restangular.all('users');
	var core = Restangular.all('core');
	var services = Restangular.all('services');
	var payments = Restangular.all('payments');
	var apple = Restangular.all('apple');
	var utility = Restangular.all('utility');
	var pay2you= Restangular.all('pay2you-external');
	var otp = Restangular.all('otp');
	var booking = Restangular.all('booking');
	var commissions = Restangular.all('commissions');
	var masterpass = Restangular.all('masterpass');
	var households = Restangular.all('households');
	var vocabularies = Restangular.all('vocabularies');

	function watchResponse(promise, resolveCb, rejectCb) {
		promise().then(function (response) {
			var readyIn = response.headers('Retry-After');

			if (readyIn) {
				return $timeout(
					function () {
						watchResponse(promise, resolveCb, rejectCb);
					},
					readyIn * 1000
				);
			}

			resolveCb(response.data);
		}).catch(function (reason) {
			if (reason.status === -1) {
                $timeout(
                    function () {
                        watchResponse(promise, resolveCb, rejectCb);
                    },
                    5000
                );
			} else {
                rejectCb(reason);
			}
		});
	}

	var api = {
		invoice: {},
		sessionStart: function(data) {
			var defer = $q.defer();
			var query = {};

			if (data.frameLogin) {
				query.frame_login = data.frameLogin;
			}

			watchResponse(function() {
				return session.get('start', query);
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		registryValidateUserData: function(form) {

			var defer = $q.defer();

			watchResponse(function() {
				return core.one('authentication').one('validate').post("", form);
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		userRegistry: function(form) {
			var defer = $q.defer();

			watchResponse(function() {
				return core.one('authentication').one('userRegistry').post("", {
					login: form.login,
					name: form.name,
					email: form.email,
					password: form.password,
					phone: form.phone,
					code: form.code,
					options: form.options
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		sendRecoveryPassCode: function(form) {
			var defer = $q.defer();

			watchResponse(function() {
				return core.one('authentication').one('sendRecoveryPassCode').post("", {
					login: form.login,
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		changeInfo:function (form) {
			var defer = $q.defer();

			watchResponse(function() {
				return users.one('utility').one('changeInfo').post('', {
					name: form.name,
					email: form.email
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getShortUrlData:function (urlCode) {
			var defer = $q.defer();

			watchResponse(function() {
				return utility
					.one('sh_url')
					.one('get')
					.post('', {
						sh_url: urlCode
					});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		changePassword: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return core.one('authentication').one('changePassword').post("", {
					login: data.login,
					password: data.password,
					code: data.code
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		userLogin: function(form) {
			var defer = $q.defer();

			watchResponse(function() {
				return user.one('login').post('', {
					email: form.email,
					password: form.password
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		userLogout: function() {
			var defer = $q.defer();

			watchResponse(function() {
				return user.one('logout').post('', {});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		loginReminder: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return users.one('utility').one('loginReminder').post('', {
					phone: '380' + data.phone,
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		searchServices: function(data) {
			var defer = $q.defer();
			var reg = new RegExp('^[0-9]*$');
			var req = {
				query: data.query,
				category: data.category || 0,
				lang: data.lang || localStorage.getItem('lang') || 'ua',
				limit: data.limit || 12,
				location: data.location !== void 0 ? data.location : 1,
				offset: data.offset || 0,
				sortByPayments: data.sortByPayments || false,
				twoStep: data.twoStep || false,
				service_id: ''
			};

			if (!data.query) {
                if (reg.test(data.furl)) {
                    req.service_id = data.furl;
                } else {
                    req.furl = data.furl;
                }
			}

			watchResponse(function() {
				return services.one('receivers').one('searchServices').post('', req);
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getServices: function(data) {
			var defer = $q.defer();

			if (data.category && !Array.isArray(data.category)) {
				data.category = [data.category];
			}

			watchResponse(function() {
				return services.one('receivers').one('getServices').post('', {
					query: data.query,
					furl: data.furl,
					category: data.category || 0,
					lang: data.lang || localStorage.getItem('lang') || 'uk',
					limit: data.limit || 12,
					location: data.location !== void 0 ? data.location : 1,
					offset: data.offset || 0,
					sortByPayments: data.sortByPayments || false,
					twoStep: data.twoStep || false,
					onlyFavorites: data.onlyFavorites || false,
                    hiddenCategory: data.hiddenCategory || null
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		//favoriteServices
			addFavorServices: function(data) {
				var defer = $q.defer();

				watchResponse(function() {
					return services.one('receivers').one('addFavorServices').post('', data);
				}, function(response) {
					return defer.resolve(response);
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},

        	delFavorServices: function(data) {
				var defer = $q.defer();

				watchResponse(function() {
					return services.one('receivers').one('delFavorServices').post('', data);
				}, function(response) {
					return defer.resolve(response);
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},

			getFavorServices: function(data) {
				var defer = $q.defer();

				watchResponse(function() {
					return services.one('receivers').one('getFavorServices').post('', {
						data: data
					});
				}, function(response) {
					return defer.resolve(response);
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},

		//end favoriteServices
		searchServicesCategory: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return services.one('receivers').one('searchServices').post('', {
					category: data.category,
					lang: data.lang,
					limit: data.limit,
					location: data.location,
					offset: data.offset,
					query: data.query,
					furl: data.furl,
					sortByPayments: data.sortByPayments
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getService: function(serviceId, url, lang) {
			var defer = $q.defer();
			var data = {};
			var link = url || serviceId;

			data.lang = lang || 'uk';

			watchResponse(function() {
				return services.get(link, data);
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getPaymentReceipt: function(paymentId) {

			var defer = $q.defer();

			watchResponse(function() {
				return payments
					.one('history')
					.one('receipt')
					.post('', {
						payment_id: paymentId
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		c2cGetPayStatus: function(data) {

			var defer = $q.defer();

			watchResponse(function() {
				return utility
					.one('p2p')
					.one('getPayStatus')
					.post('', {
						mErrCode: 0,
						mPayNumber: data.mPayNumber,
						mPayStatus: data.mPayStatus
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		c2cGetTariffs: function(data) {

			var defer = $q.defer();

			watchResponse(function() {
				return pay2you
					.one('Info')
					.customGET('GetTariffs', {
						tarifftype: "pumb"
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},

		c2cLookup: function(data) {

			var defer = $q.defer();

			watchResponse(function() {
				return utility
					.one('p2p')
					.one('lookUp')
					.post('', {
						md: data.md,
						paRes: data.paRes,
						cvv: data.cvv
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		c2cKvitToEmail: function(data) {

			var defer = $q.defer();

			watchResponse(function() {
				return pay2you
					.one('Info')
					.one('kvitanse')
					.post('', {
						cardFrom:data.cardFrom,
						summ: data.summ,
						idClient: data.idClient,
						email: data.email
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		c2cCreateOperation: function(data) {

			var defer = $q.defer();

			watchResponse(function() {
				return utility
					.one('p2p')
					.one('card2card')
					.post('', data);

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		c2cCalcCommission: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return utility
					.one('p2p')
					.one('calcCommission')
					.post('', {
						cardFrom: data.cardFrom,
						cardFromId: data.cardFromId,
						cardTo: data.cardTo,
						cardToId: data.cardToId,
						amount: data.amount
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},

		getPaymentStatus: function(ids) {
			var defer = $q.defer();

			if (!Array.isArray(ids)) {
				ids = [ids];
			}

			watchResponse(function() {
				return payments
					.one('history')
					.one('status')
					.post('', {
						ids: ids
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		check3Dsecure: function (paymentId) {
			var defer = $q.defer();

			watchResponse(function (){
				return payments
					.one('payments')
					.one('check3dSecure')
					.post('', {
						payment_id: paymentId
					});

			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
        verifyLookup: function (paymentId, otp) {
            var defer = $q.defer();

            watchResponse(function (){
                return payments
                    .one('payments')
                    .one('verifyLookup')
                    .post('', {
                        payment_id: paymentId,
						otp: otp
                    });

            }, function (response) {
                return defer.resolve(response);
            }, function (reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		getHistory: function(data) {
			var defer = $q.defer();
			var start = new Date(data.start);
			var end  = new Date(data.end);
			var id = data.id;
			start = +new Date(new Date(start).setHours(0, 0, 0));
			end = new Date(new Date(end).setHours(0, 0, 0)).setDate(end.getDate());

			watchResponse(function() {
				return payments
					.one('history')
					.one('period')
					.post('', {
						start: start,
						end: end,
						id: id
					});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getCardHistory: function(data) {
			var defer = $q.defer();
			var start = new Date(data.start);
			var end  = new Date(data.end);
			var id = data.id;
			start = +new Date(new Date(start).setHours(0, 0, 0));
			end = new Date(new Date(end).setHours(0, 0, 0)).setDate(end.getDate());

			watchResponse(function() {
				return payments
					.one('history')
					.one('periodCard')
					.post('', {
						start: start,
						end: end,
						id: id
					});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		addCard: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return users.one('cards').one('addCard').post('', {
					number: data.number,
					name: data.name
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getCards: function() {
			var defer = $q.defer();

			watchResponse(function() {
				return users.one('cards').one('getCards').post('', {});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		updateCard: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return users.one('cards').one('updateCard').post('', {
					id: data.id,
					name: data.name
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		deleteCard: function(cardId) {
			var defer = $q.defer();

			watchResponse(function() {
				return users.one('cards').one('deleteCard').post('', {
					id: cardId
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		setDefaultCard: function(cardObj) {
			var defer = $q.defer();

			watchResponse(function() {
				return users.one('cards').one('setDefaultCard').post('', {
					id: cardObj.id,
					isDefault: cardObj.is_default
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getPaymentDataById: function(paymentId) {

			var defer = $q.defer();

			watchResponse(function() {

				return payments.one('payments').one('info').post('', { 'payment_id': paymentId } );

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		checkPayment: function(data) {

			var defer = $q.defer();


			// for mask service id 13055
			var fields = {};
			if (data.data.checkMask.changeForMask) {
				fields = data.data.checkMask.fields;
			} else {
				fields = data.fields;
			}
			//
			
			watchResponse(function() {

				return payments.one('payments').one('check').post('', {

					amount: data.amountInput || 0,
					commission: data.commission || 0,
					order_id: data.payment.order_id,
					service_id: data.payment.service_id,
					fields: fields,
					shurl: data.urlCode || null,
					partner_id: data.partner_id || null,
					template_id: data.templateId || null
				});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		createPayment: function(payment_id, data) {
			var defer = $q.defer();
			this.invoice['payment_id'] = payment_id;
			this.invoice['amount'] = data.amount;
			var d = new Date();
			this.invoice['date'] = d.toLocaleDateString('en-US');

			var query = {
				payment_id: payment_id,
				amount: data.amountInput,
				// fields: data.selectedGroup.create, //todo delete
				fields: [],
				destination: data.service.destination,
				subsidy: data.subsidy
			};

			if (data.selectedGroup.create && data.selectedGroup.create.selected) {
				query.fields = data.selectedGroup.create;
				query.fields.fields.forEach(function (field) {
					if (field.type == 'AMOUNT') {
						field.value = data.amountInput;
					}
				});
			} else if (data.checkFields) {
				query.fields = data.checkFields;
				query.fields.forEach(function (field) {
					if (field.type == 'AMOUNT') {
						field.value = data.amountInput;
					}
				});	
			}	

			//todo delete
			// if (!data.selectedGroup.create.selected) {
			// 	delete query.fields;
			// }

			watchResponse(function() {
				return payments.one('payments').one('create').post('', query);
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		confirmPayment: function(payment_id, source, createTemplate, email, phone, options) {

            var defer = $q.defer();
			var PHONE_PREFIX = '380';
			var data = {
				payment_id: payment_id,
				source: source,
                create_template: createTemplate || false,
                clientEmail: email,
                userMobilePhone: phone || '',
                options: options
            };

            if (data.userMobilePhone && String(data.userMobilePhone).substr(0,3) !== PHONE_PREFIX) {
                data.userMobilePhone = PHONE_PREFIX + phone;
            }

            watchResponse(function () {
                return payments.one('payments').one('confirm').post('', data);
            }, function(response) {
                return defer.resolve(response);
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
		},
		applePayMerchantValidation: function(validation_url, domain) {
            var defer = $q.defer();

            watchResponse(function () {
                return apple.one('session').post('', {
					"validation_url": validation_url,
					"context": domain
				});
            }, function(response) {
                return defer.resolve(response);
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
		},
		subscribeToBills: function (paymentId) {
			var defer = $q.defer();
			var data = {
				paymentId: paymentId
			};

			watchResponse(function() {
				return payments.one('bills').one('subscribe').post('', data);
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getBills: function (data) {
			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('bills').one('getBills').post('', {
					dateFrom: data.dateFrom,
					dateTo: data.dateTo,
					offset: data.offset || 0,
					limit: data.limit || 12
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getSubscribers: function (data) {
			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('bills').one('getSubscribers').post('', {
					onlyActive: false
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		changeSubscribeStatus: function (data) {
			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('bills').one('changeSubscribeStatus').post('', data);
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		editSubscriptionName: function (data) {
			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('bills').one('editSubscriptionName').post('', data);
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getTemplates: function(data) {

			var defer = $q.defer();

			watchResponse(function() {

				return payments.one('templates').one('getList').post('', {});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		setTemplateNewName: function(obj) {
			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('templates').one('updateName').post('', {
					name: obj.template_name,
					id: obj.template_id
				});
			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		updateStatus: function(data) {

			var defer = $q.defer();

			watchResponse(function() {

				return payments.one('templates').one('updateStatus').post('', {
					template_id: data.template_id,
					service_id: data.service_id,
					archive: data.archive
				});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		feedback: function(form) {

			var defer = $q.defer();

			watchResponse(function() {
				return users.one('feedback').one('sendEmail').post('', form);
			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});


			return defer.promise;
		},
        getPayDocumentsList: function(paymentId) {

            var defer = $q.defer();

            watchResponse(function() {
                return payments
                    .one('receipt')
                    .one('printReceipt')
                    .post('', {
                        paymentId: paymentId
                    });

            }, function(response) {
                return defer.resolve(response);
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
        sendPayDocuments: function(opt) {

            var defer = $q.defer();

            watchResponse(function() {
                return payments.one('receipt').one('sendReceiptPDF').post('', {
                    paymentId: opt.paymentId,
                    email: opt.email
                });
            }, function (response) {
                return defer.resolve(response);
            }, function (reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		sendReceipt: function(opt) {

			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('receipt').one('sendReceipt').post('', {
					paymentId: opt.paymentId,
					email: opt.email
				});
			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});


			return defer.promise;
		},
		getReceiptP2P: function(opt) {

			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('receipt').one('getReceiptP2P').post('', {
					cardFrom: opt.cardFrom,
					cardTo: opt.cardTo,
					extPayId: opt.extPayId,
					date: opt.date,
					amount: opt.amount,
					commission: opt.commission
				});
			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		sendReceiptP2P: function(opt) {

			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('receipt').one('sendReceiptP2P').post('', {
					cardFrom: opt.cardFrom,
					cardTo: opt.cardTo,
					extPayId: opt.extPayId,
					date: opt.date,
					amount: opt.amount,
					commission: opt.commission,
					email: opt.email
				});
			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});


			return defer.promise;
		},
		//login, password, auto_login, abcode
		keLogin: function (data) {
			var defer = $q.defer();

			watchResponse(function (){
				return utility
					.one('kievenergo')
					.one('getToken')
					.post('', data);

			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		keLogout: function (data) {
			var defer = $q.defer();

			watchResponse(function (){
				return utility
					.one('kievenergo')
					.one('logout')
					.post('', {
						app: data
					});

			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		keGetAccountInfo: function (abcode, app) {
			var defer = $q.defer();

			watchResponse(function (){
				return utility
					.one('kievenergo')
					.one('getInfo')
					.post('', {
						abcode: abcode,
						app: app
					});
			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		isAuthorised: function (app) {
			var defer = $q.defer();

			watchResponse(function (){
				return utility
					.one('kievenergo')
					.one('isAuthorised')
					.post('', {
						app: app
					});
			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		//abcode, counter1, counter2, counter3
		kePutCountersValue: function (data) {
			var defer = $q.defer();

			watchResponse(function (){
				return utility
					.one('kievenergo')
					.one('putCounters')
					.post('', data);

			}, function (response) {
				return defer.resolve(response);
			}, function (reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		searchCity: function (name,loc) {
			var defer = $q.defer();
			name = name || '';
			var local;
			if(loc){local = loc}else{local = 'rus'}
			watchResponse(function() {
				return payments
					.one('points')
					.one('searchCities')
					.post('', {
						name: name,
						local:local
					});

			}, function(response) {
				return defer.resolve(response);
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		removeTemplate: function(id) {
			return payments
				.one('templates')
				.one('remove')
				.post('', {
					template_id: id
				});
		},
		getInfo: function(cardId) {
			var defer = $q.defer();
			watchResponse(function() {
				return users.one('prepaid').one('getInfo').post('', {
					id: cardId
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		smsCheck: function(id, type) {
			var defer = $q.defer();
			watchResponse(function() {
				return utility.one('otp').one('send').post('', {
					id: id,
					action: type
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		/* main page. history by phone */
			historySmsSend: function(mobilePhone) {
				var defer = $q.defer();
				watchResponse(function() {
					return otp.one('history').one('send').post('', {
						mobilePhone: mobilePhone
					});
				}, function(response) {
					return defer.resolve(response.plain());
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},
			historySmsCheck: function(data) {
				var defer = $q.defer();
				watchResponse(function() {
					return otp.one('history').one('check').post('', {
						mobilePhone: data.phone,
						code: data.code
					});
				}, function(response) {
					return defer.resolve(response.plain());
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},
			historyGetBills: function(data) {
				var defer = $q.defer();
				watchResponse(function() {
					return payments.one('history').one('periodPhone').post('', {
                        startDate: data.startDate,
                        endDate: data.endDate,
                        limit: data.limit,
                        offset: data.offset
					});
				}, function(response) {
					return defer.resolve(response.plain());
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},
			printBill: function(data) {
				var defer = $q.defer();

				watchResponse(function() {
					return payments.one('history').one('receipt').post('', {
                        payment_id: data.payment_id,
                        mobilePhone: data.mobilePhone
					});
				}, function(response) {
					return defer.resolve(response);
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},
			sendBillToMail: function(data) {
				var defer = $q.defer();

				watchResponse(function() {
					return payments.one('receipt').one('sendReceipt').post('', {
                        paymentId: data.paymentId,
                        // mobilePhone: data.mobilePhone,
                        email: data.email
                    });
				}, function(response) {
					return defer.resolve(response);
				}, function(reason) {
					return defer.reject(reason);
				});

				return defer.promise;
			},
		/* end. main page. history by phone */
		enable3DS: function(id) {
			var defer = $q.defer();
			watchResponse(function() {
				return users.one('prepaid').one('enable3DS').post('', {
					id: id
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		disable3DS: function(id, code) {
			var defer = $q.defer();
			watchResponse(function() {
				return users.one('prepaid').one('disable3DS').post('', {
					id: id,
					code: code
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		blockCard: function(id) {
			var defer = $q.defer();
			watchResponse(function() {
				return users.one('prepaid').one('blockCard').post('', {
					id: id
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		unblockCard: function(id, code) {
			var defer = $q.defer();
			watchResponse(function() {
				return users.one('prepaid').one('unblockCard').post('', {
					id: id,
					code: code
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		addScore: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return payments.one('npscore').one('addScore').post('', {
					payment_id: data.id,
					score: data.score,
					region: data.location,
					email: data.email,
					comment: data.comment
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
        bindService: function(data) {
            var defer = $q.defer();
            watchResponse(function() {
                return utility.one('kievenergo').one('bindService').post('', {
                    serviceId: data.serviceId,
                    abcode: data.abcode,
                    app: data.app
                });
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
        getCombo: function(data) {
            var defer = $q.defer();

            var requestParams = {
                q: data.query,
            };
            if (data.param) {
                requestParams.param = data.param;
            }
            if (data.size) {
                requestParams.size = data.size;
            }
            // server validates "from" as positive_integer, so 0 (first page) must be omitted
            if (data.from) {
                requestParams.from = data.from;
            }

            watchResponse(function() {
				return vocabularies.get(data.vocabulary, requestParams);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
        getEventsMetalist: function(serviceId) {
			var defer = $q.defer();
			watchResponse(function() {
				return booking.one('metalist').one('getEvents').post('', {
                    serviceId:serviceId
				});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getStadiumScheme: function(data) {
			var defer = $q.defer();
			watchResponse(function() {
				return booking.one('metalist').one('getSectorsList').post('', {
								eventId: data.eventId,
                    			serviceId: data.serviceId
							});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getSectorScheme: function(data) {
			var defer = $q.defer();
			watchResponse(function() {
				return booking.one('metalist').one('getPlaces').post('', {
								eventId: data.eventId,
								sectorId: data.sectorId,
                    			serviceId: data.serviceId
                });
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
        calculateCommission: function(data) {
            var defer = $q.defer();
            watchResponse(function() {
                return payments.one('commissions').one('calculate').post('', data);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
        searchTrips: function(data) {
            var defer = $q.defer();
            watchResponse(function() {
                return booking.one('etravels').one('searchTrips').post('', data);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
        getTripSeats: function(data) {
            var defer = $q.defer();
            watchResponse(function() {
                return booking.one('etravels').one('getTripSeats').post('', data);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		getBookingEvents: function(data) {
            var defer = $q.defer();
			var query = {
				lang: data.lang || 'uk'
			}
            watchResponse(function() {
                return booking.get('services/' + data.id + '/events', query);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		getBookingEvent: function(data) {
            var defer = $q.defer();
			var query = {
				lang: data.lang || 'uk'
			}
            watchResponse(function() {
                return booking.get('services/' + data.id + '/events/' + data.eventId, query);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		getEventlayouts: function(data) {
            var defer = $q.defer();
			var query = {
				lang: data.lang || 'uk'
			}
            watchResponse(function() {
                return booking.get('services/' + data.id + '/events/' + data.eventId + '/layouts', query);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		getEventlayout: function(data) {
            var defer = $q.defer();
			var query = {
				lang: data.lang || 'uk'
			}
            watchResponse(function() {
                return booking.get('services/' + data.id + '/events/' + data.eventId + '/layouts/' + data.layout_id, query);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		putReserveTicket: function(data) {
            var defer = $q.defer();
			var query = {
				lang: data.lang || 'uk',
				typeId: data.selectedType
			}
            watchResponse(function() {
                return booking.one('services/' + data.id).one('events/' + data.eventId).one('layouts/' + data.layout_id).one('reserve?typeId=' + query.typeId + '&lang=' + query.lang).post('', '');
                // return booking.customPUT('', 'services/' + data.id + '/events/' + data.eventId + '/layouts/' + data.layout_id + '/reserve?legendId=' + query.legendId + '&lang=' + query.lang);
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		deleteReserveTicket: function(data) {
            var defer = $q.defer();
			var query = {
				lang: data.lang || 'uk',
				legendId: data.legendId,
				remove: data.removeTicket
			};

            watchResponse(function() {
				return booking.customPUT({ids: query.remove}, 'services/' + data.id + '/events/' + data.eventId + '/layouts/' + data.layout_id + '/reserve');
				// return booking.customOperation('remove', 'services/' + data.id + '/events/' + data.eventId + '/layouts/' + data.layout_id + '/reserve', '',{'Content-Type': 'application/json; charset=utf-8'},{ids: query.remove});
            }, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		bookingDiscount: function(data) {
			var defer = $q.defer();
			var query = {
				amount: data.amount,
				serviceId: data.serviceId,
				source: {
					cardFrom: {
						number: data.source.cardFrom.number || '',
						id: data.source.cardFrom.id || ''
					}
				}
			};
            watchResponse(function() {
                return commissions.one('calculate').post('', data);
			}, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		masterpassAddCard: function(data) {
			var defer = $q.defer();
			var query = {
				alias: data.name,
				pan: data.pan,
				exp: data.exp,
				cvv: data.cvv
			};
            watchResponse(function() {
                return masterpass.one('card').one('add').post('', data);
			}, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
        },
		masterpassCodeValidate: function(data) {
			var defer = $q.defer();
            watchResponse(function() {
                return masterpass.one('code').one('validate').post('', data);
			}, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
		},
		masterpassAuth: function(data) {
			var defer = $q.defer();
			var query = {
				msisdn: '380'+data.msisdn,
				pin: data.pin,
				payment_id: data.payment_id
			};
            watchResponse(function() {
                return masterpass.one('auth').one('pin').post('', query);
			}, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
		},
		masterpassLogout: function(data) {
			var defer = $q.defer();
            watchResponse(function() {
                return masterpass.one('auth').remove('');
			}, function(response) {
                return defer.resolve(response.plain());
            }, function(reason) {
                return defer.reject(reason);
            });

            return defer.promise;
		},
		initMPWalletLink: function() {
			var defer = $q.defer();

			watchResponse(function() {
				return masterpass.one('cards').one('link').post('', {});
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		confirmMPWalletLinkOTP: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return masterpass.one('cards').one('link').one('confirm').post('', data);
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});

			return defer.promise;
		},
		getHouseholds: function() {
			var defer = $q.defer();
			watchResponse(function() {
				return households.get('households');
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});
			return defer.promise;
		},
		addHHTemplate: function(data, token) {
			var defer = $q.defer();
			var options = {
				'User-token': token
			}

			watchResponse(function() {
				return households.one(data.hhID).one('templates').post('', data.data);
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});
			return defer.promise;
			//
		},
		renameHHTemplate: function(data) {
			var defer = $q.defer();
			var query = {
				name: data.query.name,
				status: data.query.status,
			}

			watchResponse(function() {
				return households.customPUT(query, data.hhID + '/templates/' + data.tmplID);
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});
			return defer.promise;
			//
		},
		deleteHHTemplate: function(data) {
			var defer = $q.defer();

			watchResponse(function() {
				return households.one(data.hhID).one('templates').one(data.tmplID).remove();
			}, function(response) {
				return defer.resolve(response.plain());
			}, function(reason) {
				return defer.reject(reason);
			});
			return defer.promise;
			//
		},
	};

	return api;
}

module.exports = 'portal-api';



/*****************
 ** WEBPACK FOOTER
 ** ./app/components/portal_api/index.js
 ** module id = 111
 ** module chunks = 1
 **/